import React, { useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getDetailEntete } from "../../Redux/importFactureReduce";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
import Configuration from "../../configuration";

function DetailsImportFacture({ obj }) {
  const dispatch = useDispatch();
  const location = useParams();
  const idFacture = location.id;
  const token = localStorage.getItem("x-access-token");
  const decoded = jwt_decode(token);

  const [facture, setFacture] = useState({});
  const [loader, setLoader] = useState(true);
  const [files, setFiles] = useState([]); // <-- plusieurs fichiers

  /* detailFacture*/
  const detailFacture = useCallback(
    async (idFacture) => {
      const dataFacture = await dispatch(getDetailEntete({ idFacture }));
      setFacture(dataFacture.payload);
      setLoader(false);
    },
    [dispatch]
  );

  useEffect(() => {
    detailFacture(idFacture);
  }, [idFacture, detailFacture]);



  return (
    <>
      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <Container fluid>

          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={() => window.history.back()}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t("list")}
              </Button>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Détails Facture</Card.Title>
                </Card.Header>
                <Card.Body>
                  <br />
                  <table className="table table-bordered">
                    <thead>
                      <tr className="table-info">
                        <th>Code Grossiste</th>
                        <th>Grossiste</th>
                        <th>Date d'enlevement</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{facture.Code_client}</td>
                        <td>{facture.Raison_sociale}</td>
                        <td>{facture.date_enlevement}</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  {

                    facture && facture.files.length > 0 && (
                      <div>
                        {facture.files.map((f, idx) => (

                          f.file != null && <>
                            <h3><strong>{f.num_facture}</strong></h3>
                            <iframe
                              key={idx}
                              src={`${Configuration.BACK_BASEURL}facture/${f.file}`}
                              width="100%"
                              height="600px"
                              style={{ border: "none", marginBottom: "20px" }}
                              title={f.num_facture}
                            ></iframe> </>


                        ))}
                      </div>
                    )

                  }

                  <div className="clearfix"></div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default DetailsImportFacture;
